import type { Hand, Score } from '../music/model';
import { measureCount, ticksPerMeasure, ticksToMs } from '../music/model';

export function formatDuration(ms: number): string {
  const total = Math.max(0, Math.round(ms / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}

export function formatMinutes(ms: number): string {
  const minutes = Math.round(ms / 60000);
  if (minutes < 1) return 'moins d’une minute';
  if (minutes === 1) return '1 minute';
  if (minutes < 60) return `${minutes} minutes`;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m === 0 ? `${h} h` : `${h} h ${m.toString().padStart(2, '0')}`;
}

export function scoreDurationMs(score: Score, tempo: number = score.tempo): number {
  return ticksToMs(measureCount(score) * ticksPerMeasure(score), tempo, score.ppq);
}

export function handLabel(hand: Hand, short = false): string {
  if (short) return hand === 'right' ? 'MD' : 'MG';
  return hand === 'right' ? 'Main droite' : 'Main gauche';
}

export function percent(value: number): string {
  return `${Math.round(value * 100)} %`;
}

export function levelLabel(level: number): string {
  return ['', 'Découverte', 'Facile', 'Intermédiaire', 'Avancé', 'Expert'][level] ?? `Niveau ${level}`;
}
